import React from 'react';
import {
  StyledProductImage,
  StyledRowProduct,
  StyledCardContent,
  StyledTableContainer,
  StyledTableCell,
  StyledBoxLinearProgress,
  StyledTableRow,
  StyledSelectColumn,
} from './index.style';
import { Avatar, LinearProgress, Paper as MuiPaper, MenuItem, Stack, Menu, CircularProgress } from '@mui/material';
import { StyledCardItems } from './index.style';
import Box from 'component/layoutComponents/Box';
import Typography from 'component/MarketPlace/Typography';
import { Button } from 'component/MarketPlace/ButtonComponents';
import { IconButton } from 'component/MarketPlace/ButtonComponents';
import { mapOrderStatus } from 'component/MarketPlace/OrderRequestDetail/utils/index';
import TaskProgress from '../TaskProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { getAvatarName } from 'utils/functions';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EyeBrow from 'component/MarketPlace/eyeBrow/eyeBrow';
import { ORDER_STATUS, STATUS_TEXT } from '../../MarketPlace/OrderRequestDetail/constant/index';
import { ActOnBehalfIcon } from 'component/layoutComponents/overlay/overlay';
import { useTheme } from 'styled-components';
import DefaultUptimeTheme from 'component/theme/defaultTheme';
import moment from 'moment';

export interface INewJoinerCard {
  content?: any;
  handleSendMail: (id: string, first_name: string) => void;
  doneList?: any;
  loadingTask?: boolean;
  isChangeColor?: any;
  getDateProgress?: any;
  setShowDialog?: any;
  total?: number;
  handlePendingApproveClick?: () => void;
  locale: any;
  handleSubmitActOnBehalf: (newjoinerInfo: any) => void;
  isChangeColorAccessDays?: any;
  isChangeColorStartDays?: any;
  setIsOpenDrawer?: any;
};

export type TaskStatus = 'pending' | 'completed'

export type NewJoinerTask = {
  id?: string;
  joiner_id?: string;
  task_definition_id: string;
  status: TaskStatus;
  completed?: string;
  name?: string;
  description?: string;
  url?: string;
  file_type?: string;
  img?: string;
  active?: boolean;
  picture?: string;
};

type MenuContentProps = {
  handleOpenOnBoarding: () => void;
  handleSendMail: () => void;
  onViewDetails: () => void;
  locale?: any;
  handleOpenOffBoarding: () => void;
};

const ApprovalMenuItems = ({ handleOpenOnBoarding, handleSendMail, locale, handleOpenOffBoarding }: { handleOpenOnBoarding: () => void; handleSendMail: () => void; locale: any, handleOpenOffBoarding: () => void }) => {
  return (
    <Box>
      <MenuItem onClick={handleOpenOnBoarding}>
        <Box borderBottom="1px solid #D7D7D7" width="100%" padding="5px 0" display="flex" alignItems="center">
          <Typography>{locale?.newJoinerCard?.menuItem?.addEditTitle}</Typography>
        </Box>
      </MenuItem>
      <MenuItem onClick={handleSendMail}>
        <Box borderBottom="1px solid #D7D7D7" width="100%" padding="5px 0" display="flex" alignItems="center">
          <Typography>{locale?.newJoinerCard?.menuItem?.sendingTitle}</Typography>
        </Box>
      </MenuItem>
      <MenuItem onClick={handleOpenOffBoarding}>
        <Box borderBottom="1px solid #D7D7D7" width="100%" padding="5px 0" display="flex" alignItems="center">
          <Typography>{locale?.newJoinerCard?.menuItem?.cancelTitle}</Typography>
        </Box>
      </MenuItem>
    </Box>
  );
};



const MenuContent = ({
  handleOpenOnBoarding,
  handleSendMail,
  locale,
  handleOpenOffBoarding
}: MenuContentProps) => {
    return <Stack>
      <ApprovalMenuItems handleOpenOnBoarding={handleOpenOnBoarding} handleSendMail={handleSendMail} locale={locale} handleOpenOffBoarding={handleOpenOffBoarding} />
    </Stack>
};

const NewJoinerCard = (props: INewJoinerCard) => {
  const { content, handleSendMail, doneList, loadingTask, isChangeColorAccessDays, isChangeColorStartDays, getDateProgress, setShowDialog, total = 0, locale, handlePendingApproveClick, handleSubmitActOnBehalf, setIsOpenDrawer } = props;

  const orderDetailsStatus: any = content?.latestOrder?.status;
  const { statusText, statusColors } = mapOrderStatus(orderDetailsStatus);
  const createdOn = content?.latestOrder?.createdOn;
  const products: any = content?.latestOrder?.products;
  const filteredProducts: any = products?.filter((item: any) => item.status !== ORDER_STATUS.CANCELED);
  const isProduct = products?.length > 0 ? true : false;
  const progress = doneList?.length / total;
  const isOrdered = content?.latestOrder ? true : false;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openActionMenu = Boolean(anchorEl);
  const shippedDate = content?.latestOrder?.products[0]?.statusHistory?.find((s: any) => s.status === "shipped") || '';
  const theme = useTheme() as typeof DefaultUptimeTheme;
  
  const handleCloseActionMenu = () => {
    setAnchorEl(null);
  };

  const handleClickActionMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleOpenOnBoarding = () => {
    setShowDialog(true);
    setAnchorEl(null);
  };

  const handleOpenOffBoarding = () => {
    setIsOpenDrawer(true);
    setAnchorEl(null);
  };

  const handleRenderSubmitActOnBehalf: any = () => {
    return (
      <Button 
        sx={{ width: '100%', fontSize: `${theme.uptimeFontSizes.desktop.fz2}px`, whiteSpace: "nowrap" }}
        startIcon={<ActOnBehalfIcon color={theme.uptimeColors.grayScales.white}/>} 
        size="medium" 
        fullWidth 
        onClick={() => handleSubmitActOnBehalf(content)}
      >
        {(locale?.newJoinerCard?.orderOnBehalf)}
      </Button>
    )
  };

  return (
    <MuiPaper
      variant='outlined'
      sx={{
        borderRadius: '8px',
        paddingTop: '16px',
        '&:hover': { boxShadow: "0 1px 2px -2px rgba(0, 0, 0, 0.16),  0 3px 6px 0 rgba(0, 0, 0 , 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09) !important" },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        px={4}
      >
        <Box display={{sx: "block" , lg: "flex"}} alignItems="center">
          <Avatar src={content?.avatar} sx={{ width: 70, height: 70, mr: '26px' }}>
            {!content?.avatar && (
              <Typography variant="h4">
              {getAvatarName(content?.first_name + ' ' + content?.last_name || '')}
            </Typography>
            )}
          </Avatar>
          <Box marginRight="26px" minWidth="230px">
            <Typography
              fontSize="22px"
              fontWeight="500"
              lineHeight="normal"
            >
              {content?.first_name + ' ' + content?.last_name}
            </Typography>
            <Typography
              color="text.secondary"
              fontSize="14px"
              fontWeight="400"
              lineHeight="20px"
            >
              {content?.job_title}
            </Typography>
          </Box>
          <StyledBoxLinearProgress isChangeColor={isChangeColorStartDays} marginRight="6%">
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography
                color="text.secondary"
                fontSize="14px"
                fontWeight="500"
                lineHeight="20px"
              >
                {locale?.newJoinerCard?.cardJoiner?.startdate}:
              </Typography>
              <Typography
                color="primary"
                fontSize="14px"
                fontWeight="500"
                lineHeight="20px"
              >
                {content?.start_date}
              </Typography>
            </Box>
            <LinearProgress variant="determinate" value={getDateProgress(content?.start_date)} />
          </StyledBoxLinearProgress>
          <StyledBoxLinearProgress isChangeColor={isChangeColorAccessDays}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography
                color="text.secondary"
                fontSize="14px"
                fontWeight="500"
                lineHeight="20px"
              >
                {locale?.newJoinerCard?.cardJoiner?.startAccessDate}:
              </Typography>
              <Typography
                color="primary"
                fontSize="14px"
                fontWeight="500"
                lineHeight="20px"
              >
                {moment(content?.start_access_date).format('dddd DD MMMM YYYY')}
              </Typography>
            </Box>
            <LinearProgress variant="determinate" value={getDateProgress(content?.start_access_date)} />
          </StyledBoxLinearProgress>
        </Box>
      </Box>

      <Box borderBottom="8px">
        <StyledTableContainer isProduct={isProduct}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <StyledTableRow sx={{ height: '32px' }}>
                <StyledTableCell sx={{ width: '150px' }} align="center">
                  <Typography variant="overline" fontWeight="700" color="rgba(0, 0, 0, 0.60)">
                    {locale?.newJoinerCard?.cardJoiner?.orderNumber}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell sx={{ width: '200px' }} align="center">
                  <Typography variant="overline" fontWeight="700" color="rgba(0, 0, 0, 0.60)">
                    {locale?.newJoinerCard?.cardJoiner?.status}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell sx={{ width: '160px' }} align="center">
                  <Typography variant="overline" fontWeight="700" color="rgba(0, 0, 0, 0.60)">
                    {locale?.newJoinerCard?.cardJoiner?.ordered}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell sx={{ width: '160px' }} align="center">
                  <Typography variant="overline" fontWeight="700" color="rgba(0, 0, 0, 0.60)">
                    {locale?.newJoinerCard?.cardJoiner?.shipped}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell sx={{ width: '220px' }} align="center">
                  <Typography variant="overline" fontWeight="700" color="rgba(0, 0, 0, 0.60)">
                    {locale?.newJoinerCard?.cardJoiner?.onboardingTasks}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Typography variant="overline" fontWeight="700" color="rgba(0, 0, 0, 0.60)">
                    {locale?.newJoinerCard?.cardJoiner?.managerAction}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Typography variant="overline" fontWeight="700" color="rgba(0, 0, 0, 0.60)">
                    {locale?.newJoinerCard?.cardJoiner?.select}
                  </Typography>
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="center">
                  {isOrdered && !(statusText === STATUS_TEXT[ORDER_STATUS.CANCELED])
                    ? `#${content?.latestOrder?._id?.slice(0, 5)}`
                    : locale?.newJoinerCard?.noOrder}
                </TableCell>
                <TableCell align="center">
                  {isOrdered ? (
                    statusText === STATUS_TEXT[ORDER_STATUS.PENDING_APPROVAL] ? (
                      <Button 
                      sx={{ width: '100%', fontSize: `${theme.uptimeFontSizes.desktop.fz2}px`, whiteSpace: "nowrap" }}
                      size="medium" 
                      fullWidth 
                      onClick={handlePendingApproveClick}
                    >
                      {locale?.mockFilterStatus?.pendingApproval}
                    </Button>
                    ): statusText === STATUS_TEXT[ORDER_STATUS.CANCELED] ? (handleRenderSubmitActOnBehalf()) : (<EyeBrow
                      size="small"
                      color={statusColors.type}
                      label={locale?.commonStatus?.[orderDetailsStatus.toUpperCase()] || statusText}
                      variant="filled"
                      sx={{
                        backgroundColor: statusColors.backgroundColor,
                        color: statusColors.color,
                        fontWeight: 600,
                        textTransform: 'uppercase',
                      }}
                    />)
                  ) : (handleRenderSubmitActOnBehalf())}
                </TableCell>
                <TableCell align="center">
                  {isOrdered ? createdOn : '-'}
                </TableCell>
                <TableCell align="center">
                  {shippedDate ? shippedDate?.created_on : '-'}
                </TableCell>
                <TableCell align="center">
                  {loadingTask ? (
                    <CircularProgress color='primary'/>
                  ) : (
                    <TaskProgress
                    doneList={doneList}
                    total={total}
                    progress={progress}
                    locale={locale}
                  />
                  )} 
                </TableCell>
                <TableCell align="center">
                <a href={`mailto:${content?.email}; ${content?.personal_email}`}>
                  <Button
                    sx={{ width: '100%', fontSize: "12px", whiteSpace: "nowrap" }}
                    endIcon={<ChevronRightIcon />}
                    size="medium"
                    fullWidth
                  >
                    {locale?.newJoinerCard?.cardJoiner?.btnContact}
                  </Button>
                  </a>
                </TableCell>
                <TableCell align="center">
                  <StyledSelectColumn>
                  <IconButton
                      icon={MoreVertIcon}
                      fontSize="small"
                      size="small"
                      color="inherit"
                      onClick={handleClickActionMenu}
                      aria-label="Action Button"
                    />
                    <Menu
                      anchorEl={anchorEl}
                      open={openActionMenu}
                      onClose={handleCloseActionMenu}
                      disableScrollLock
                    >
                      <MenuContent
                        handleOpenOnBoarding={handleOpenOnBoarding}
                        handleSendMail={() => {handleSendMail(content?.id, content?.first_name);setAnchorEl(null);}}
                        locale={locale} 
                        onViewDetails={() => {}}
                        handleOpenOffBoarding={handleOpenOffBoarding} />
                    </Menu>
                  </StyledSelectColumn> 
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </StyledTableContainer>
      </Box>

      {filteredProducts?.length > 0 && (
        <StyledCardContent>
          <StyledRowProduct>
            {filteredProducts.map((item: any) => {
              return (
                <StyledCardItems key={item}>
                  <StyledProductImage>
                    <img
                      src={item?.pictures[0]?.small}
                      alt={item?.genericName}
                      title={item?.genericName}
                    />
                  </StyledProductImage>
                  <EyeBrow
                    color="default"
                    label={item.quantity}
                    variant="filled"
                  />
                </StyledCardItems>
              );
            })}
          </StyledRowProduct>
        </StyledCardContent>
      )}
    </MuiPaper>
  );
};

export default NewJoinerCard;
